import { Team } from '@/types'
import { twMerge } from 'tailwind-merge'
import { ComponentProps } from 'react'
import { Button } from 'flowbite-react'
import { Users } from 'flowbite-react-icons/solid'
import { Session } from 'next-auth'
import Link from 'next/link'
import { format } from 'date-fns'
import { Edit } from 'flowbite-react-icons/solid'
import { TeamMemberList } from './TeamMemberList'

interface TeamProps extends ComponentProps<'div'> {
  team: Team
  currentUser: Session['user']
  isLeader: boolean
  isMember: boolean
  isfirstRoundEnded: boolean
  eventSlug: string
}

export const TeamPanel = ({
  team,
  currentUser,
  isLeader,
  isMember,
  isfirstRoundEnded,
  children,
  eventSlug,
  ...props
}: TeamProps) => {
  const leader = team.team_members.find((m) => m.role === 'leader')

  return (
    <div
      className={twMerge(
        'flex flex-col p-5 my-5 border border-gray-200 rounded-lg',
        props.className
      )}
    >
      <div className="flex flex-row items-center justify-center pb-3 mb-5 border-b border-gray-200">
        <div className="flex flex-col flex-1">
          <p className="text-gray-900 font-semibold text-2xl">{team.name}</p>
          <p className="text-sm text-gray-500 flex items-center">
            <Edit className="w-6 h-6 inline text-gray-700" />
            Last Updated
            {format(team.updated_at, ' dd MMM yyyy, HH:mm')}
          </p>
        </div>
        {isLeader && !isfirstRoundEnded && (
          <Button
            as={Link}
            outline
            color="light"
            className="max-h-11"
            href={`/web/events/${eventSlug}/team/${team.id}/edit`}
          >
            Manage Team
          </Button>
        )}
      </div>

      <div className="w-full">
        <h3 className="text-gray-900 text-lg font-medium mb-1">
          Current team members
        </h3>
        <div className="flex flex-row">
          <Users className="w-5 h-5 mr-1 text-gray-500" />
          <p className="text-sm text-gray-500">
            {team.team_members.length} members
          </p>
        </div>
        <p className="text-sm text-gray-500 py-3">
          Only the team leader,{' '}
          <span className="text-gray-900">{leader && `${leader.name}`}</span>,
          may add team members and submit on behalf of the team.
        </p>

        <div className="mb-2 flex flex-col space-y-3 mt-3">
          <TeamMemberList
            teamMember={team.team_members}
            currentUser={currentUser}
          ></TeamMemberList>
        </div>
      </div>
    </div>
  )
}
